import { API_URL } from "env";

export interface CartProduct {
    id: number;
    name: string;
    slug: string;
    avatar: string;
    alt: string;
    product_category_id: number;
    price: number;
    discount: number;
    content: string;
    short_content: string;
    is_active: number;
    is_stock: number;
    star: number;
    product_category: {
        id: number;
        name: string;
        slug: string;
    };
    promotion_product: any[];
    promotion_flash_sale_product: any[];
}
export interface CartItems {
    id: number;
    customer_id: number;
    product_id: number;
    is_check: number;
    quantity: number;
    created_at: string;
    updated_at: string;
    product: CartProduct;
}

export interface CartItemsResponse { items: CartItems[], current_page: number, total: number }

async function listCartItems(): Promise<CartItemsResponse> {
    try {
        const response = await fetch(API_URL + '/api/v1/fe/cards', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
            },
        });

        if (!response.ok) {
            if (response.status === 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                console.warn('Unauthorized access - perhaps the user is not logged in.');
                return { items: [], current_page: 0, total: 0 };
            }
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data.data || { items: [], current_page: 0, total: 0 };
    } catch (error) {
        console.error('Failed to fetch cart items:', error);
        return { items: [], current_page: 0, total: 0 }
    }
}

async function addItemToCart(product_id: string, quantity: number): Promise<void> {
    try {
        const data = new FormData();
        data.append('product_id', product_id);
        data.append('quantity', quantity.toString());
        const response = await fetch(API_URL + '/api/v1/fe/card', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
            },
            body: data,
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        console.log('Item added to cart successfully');
        window.dispatchEvent(new Event('cart-updated'));
    } catch (error) {
        console.error('Failed to add item to cart:', error);
    }
}

async function removeItemFromCart(cart_item_id: string): Promise<void> {
    try {
        const data = new FormData();
        data.append('cart_item_id', cart_item_id);
        const response = await fetch(API_URL + `/api/v1/fe/card/${cart_item_id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
            },
            body: data,
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        console.log('Item removed from cart successfully');
        window.dispatchEvent(new Event('cart-updated'));
    } catch (error) {
        console.error('Failed to remove item from cart:', error);
    }
}

async function removeMultipleItemsFromCart(cart_item_ids: string[]): Promise<void> {
    try {
        const response = await fetch(API_URL + `/api/v1/fe/card_destroy_multi?ids=${cart_item_ids.join(',')}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        window.dispatchEvent(new Event('cart-updated'));
        console.log('Multiple items removed from cart successfully');
    } catch (error) {
        console.error('Failed to remove multiple items from cart:', error);
    }
}

async function updateItemQuantity(cart_item_id: string, quantity: number): Promise<void> {
    try {
        const data = new FormData();
        data.append('quantity', quantity.toString());
        const response = await fetch(API_URL + `/api/v1/fe/card/${cart_item_id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
            },
            body: data,
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        window.dispatchEvent(new Event('cart-updated'));
        console.log('Item quantity updated successfully');
    } catch (error) {
        console.error('Failed to update item quantity:', error);
    }
}

export {
    listCartItems,
    addItemToCart,
    removeItemFromCart,
    removeMultipleItemsFromCart,
    updateItemQuantity,
};